<template>
  <div class="content">
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <EditVersion :versionInfo="versionList"/>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';
import EditVersion from '@/pages/version/editVersion';

export default {
  data () {
    return {
      navBlock: '版本',
      navtitle:'版本更新',
      listMenuForm: {
        startTime: '',
        endTime: ''
      },
      versionList: [],
      block:'',
      versionTable: [
        {
          prop: 'marketNum',
          label: '應用市場',
          width: '180'
        }, {
          prop: 'version',
          label: '當前版本',
          width: '180'
        }, {
          prop: 'updateTime',
          label: '更新時間',
          width: '180'
        },{
          prop: 'updateFlag',
          label: '是否強制更新',
          width: '180'
        }, {
          prop: 'updateUrl',
          label: '更新鏈接',
          width: ''
        }
      ],
      total: 0,
      currentPage: 1,
      dialogVisible: false,

    }
  },
  created(){

    this.roleType = localStorage.getItem('roleType')

    if ( this.roleType != null && this.roleType.indexOf('ROLE_GUEST')> -1) {

      this.getVersionList();

    } else {

      this.$router.push('/home');

    }
  },
  activated(){

    this.roleType = localStorage.getItem('roleType');

    if ((this.roleType != null) && (this.roleType.indexOf('ROLE_GUEST')) > -1 && (this.currentPage === 1)) {

      this.getVersionList();
    } else {

      this.$router.push('/home');

    }
  },
  methods:{
    getVersionList(){
      let _this = this;
      _this.$post('/request/version/getVersion', {}, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            res.data.forEach(v => {
              if (v.appMarket===0) {
                v.marketNum = 'app store';
              } else if (v.appMarket === 1) {
                v.marketNum = 'Android';
              } else if (v.appMarket === 4) {
                v.marketNum = '其他';
              }
              if (v.updateStatus === 1) {
                v.updateFlag = '是';
              } else {
                v.updateFlag = '否';
              }
            })
            _this.versionList = res.data;
          } else {
            _this.$propMessage(res.message, 'error');

          }
        });
    },
    handleCurrentChange(val){
      let _this = this;
      _this.currentPage = val;
    },
  },
  components: {
    NavBar,
    DiaMess,
    EditVersion
  }
};
</script>
<style lang="less" scoped>
  .content{
    .paddingContent{
      .tableWrap {
        width: 100%;
        height: calc(100% - 152px);
        overflow: auto;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/version/versionUpdate.vue